import logo from './matareal_logo_transparent.png'
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} alt="logo" className="matareal-logo" />
        <h1 className="waitlist-text">Save time, save money, create!</h1>
        <h2 className="waitlist-text-2">
          <a className="waitlist-link" rel="noreferrer" href="https://forms.gle/WCDEYXnEAvAsxkU19" target="_blank">Click here for a free demo</a>
        </h2>
      </header>
    </div>
  );
}

export default App;
